module.exports = __webpack_public_path__ + "img/IT0004440793059.c12dd4ac.svg";